var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"df3qMWlY2-xr77FSjVSUQ"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["one-platform@wifkain"]={id:"df3qMWlY2-xr77FSjVSUQ"};
      